import { useSearchParams } from 'next/navigation';

import { useThemeSearchParam } from '../theme/hooks/useThemeParam';

import { useCmsExploreFilters } from './useCmsExploreFilters';

export function useSearchInput() {
  const searchParams = useSearchParams();
  const { searchInput: cmsExploreSearchQuery } = useCmsExploreFilters();
  const { searchInput: themeSearchParam } = useThemeSearchParam();
  return {
    searchInput:
      cmsExploreSearchQuery || themeSearchParam || searchParams.get('q') || '',
  };
}
